<template>
  <div class="status-section">
    <div class="status-cards">
      <CardDashboard
        v-for="statusData in processedStatusData"
        :key="statusData.status"
        :title="formatStatusName(statusData.status)"
        :accent-color="statusData.color"
        :class="'status-card status-' + statusData.status"
        type="graphCard"
      >
        <template #default>
          <div class="status-header">
            <span class="status-total">{{ statusData.total }}</span>
          </div>
          <div class="account-list">
            <div v-for="account in statusData.accounts" :key="account.name" class="account-item">
              <span class="account-name">{{ account.name }}</span>
              <div class="progress-bar-wrapper">
                <div
                  class="progress-bar"
                  :style="{ width: account.percentage + '%', backgroundColor: statusData.color }"
                ></div>
              </div>
              <span class="account-value">{{ account.value }}</span>
            </div>
          </div>
        </template>
      </CardDashboard>
    </div>
  </div>
</template>

<script>
import { formatStatusName } from "@/utils/dashboardUtils";
import CardDashboard from "../../components/CardDashboard.vue";

export default {
  name: "StatusSection",
  components: {
    CardDashboard,
  },
  props: {
    processedStatusData: {
      type: Array,
      required: true,
    },
  },
  methods: {
    formatStatusName,
  },
};
</script>

<style lang="scss" scoped>
@use "@/assets/scss/_themes" as *;
@use "@/assets/scss/_variables" as *;
@use "@/assets/scss/_dashboard-mixins" as *;
@use "@/assets/scss/_mixins" as *;

.status-section {
  margin-bottom: 30px;

  .status-cards {
    @include status-grid;

    .status-card {
      @include card-base;
      overflow: visible !important; // Ensure border-top is visible

      // Dynamic status colors
      &.status-quoted {
        @include status-accent($color-status-quoted);
      }

      &.status-assigned {
        @include status-accent($color-status-assigned);
      }

      &.status-in_transit {
        @include status-accent($color-status-in-transit);
      }

      &.status-delivered {
        @include status-accent($color-status-delivered);
      }

      .status-header {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        margin-bottom: 20px;

        .status-total {
          font-size: 24px;
          font-weight: bold;
          color: #001737;
        }
      }

      .account-list {
        display: flex;
        flex-direction: column;
        gap: 12px;

        .account-item {
          display: grid;
          grid-template-columns: 140px 1fr 50px;
          align-items: center;
          gap: 12px;

          .account-name {
            font-size: 13px;
            color: #6b7280;
            font-weight: 500;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }

          .progress-bar-wrapper {
            @include progress-bar-container;

            .progress-bar {
              height: 100%;
              border-radius: 4px;
              transition: width 0.3s ease;
              min-width: 4px;
              position: absolute;
              left: 0;
              top: 0;
            }

            .account-value {
              font-size: 14px;
              font-weight: bold;
              color: #001737;
              text-align: right;
            }
          }
        }
      }
    }
  }
}

/* Responsive Design */
@media (max-width: 768px) {
  .status-section {
    margin-bottom: 24px;

    .status-cards {
      .status-card {
        .status-header {
          margin-bottom: 16px;

          .status-total {
            font-size: 20px;
          }
        }

        .account-list {
          gap: 10px;

          .account-item {
            grid-template-columns: 120px 1fr 45px;
            gap: 8px;

            .account-name {
              font-size: 12px;
            }

            .account-value {
              font-size: 12px;
            }
          }
        }
      }
    }
  }
}
</style>
